var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMylistLogoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 320,
    height: 320,
    viewBox: "0 0 320 320",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.431 263.494C129.431 280.11 115.962 293.578 99.3458 293.578C82.7296 293.578 69.2606 280.11 69.2606 263.494C69.2606 246.879 82.7296 233.411 99.3458 233.411C115.962 233.411 129.431 246.879 129.431 263.494ZM259.82 233.411C243.203 233.411 229.735 246.879 229.735 263.494C229.735 280.11 243.203 293.578 259.82 293.578C276.436 293.578 289.905 280.11 289.905 263.494C289.905 246.879 276.436 233.411 259.82 233.411ZM299.21 72.7006C288.341 73.0818 279.886 82.3473 279.886 93.2255V152.679C279.886 163.538 271.451 172.803 260.602 173.214C249.185 173.644 239.773 164.486 239.773 153.168V114.493C239.773 81.4677 213.548 53.9155 180.531 53.4072C146.927 52.899 119.422 80.0798 119.422 113.574V152.669C119.422 163.528 110.987 172.794 100.137 173.204C88.721 173.634 79.3086 164.476 79.3086 153.158V87.4981C79.3086 54.4726 53.0841 26.9203 20.0666 26.4219C8.98258 26.4219 0 35.404 0 46.4874C0 56.9942 8.07358 65.5951 18.3561 66.465V66.5529C29.7627 66.1228 39.1851 75.2809 39.1851 86.5989V93.7142C39.1851 93.7142 39.1851 93.724 39.1851 93.7338V152.259C39.1851 185.285 65.4094 212.837 98.4269 213.345C132.031 213.853 159.536 186.672 159.536 153.178V114.083C159.536 103.224 167.971 93.9585 178.82 93.548C190.237 93.118 199.649 102.276 199.649 113.594V152.269C199.649 185.294 225.874 212.847 258.891 213.345C292.495 213.853 320 186.672 320 153.178V92.7466C320 81.4286 310.626 72.2999 299.21 72.7006Z",
    fill: "url(#paint0_linear_6203_29985)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6203_29985",
    x1: -31.7111,
    y1: 249.771,
    x2: 248.351,
    y2: 44.3871,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#231FFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#2035FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#1B70FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#14BCFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMylistLogoIcon);
export default __webpack_public_path__ + "static/media/mylist-logo-icon.d986d59d5afba5141fe78cc4c44d3e30.svg";
export { ForwardRef as ReactComponent };